const features = [
  {
    icon: 'ri-shield-check-line',
    title: '品质保障',
    description: '严选全国优质产地，每批蔬菜经过多道质检，确保农药残留符合国家标准，让您吃得安心。',
  },
  {
    icon: 'ri-truck-line',
    title: '新鲜速达',
    description: '凌晨采摘，清晨配送，全程冷链运输。从田间到餐桌不超过24小时，锁住蔬菜的新鲜营养。',
  },
  {
    icon: 'ri-earth-line',
    title: '产地直供',
    description: '与500多个优质蔬菜基地建立长期合作，跳过中间环节，以更实惠的价格提供更高品质的蔬菜。',
  },
  {
    icon: 'ri-leaf-line',
    title: '应季而食',
    description: '根据二十四节气推荐当季时令蔬菜，遵循自然规律，让您吃对季节、吃出健康。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '专业客服团队7×12小时在线，随时解答您的疑问。品质问题无条件退换，售后无忧。',
  },
  {
    icon: 'ri-recycle-line',
    title: '绿色环保',
    description: '采用可降解环保包装，减少塑料使用。支持可持续农业发展，为地球减负。',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="why-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-50 text-secondary-700 text-xs font-medium rounded-full mb-4">
            为什么选择我们
          </span>
          <h3 id="why-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            新有菜，不止是新鲜
          </h3>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            六大核心优势，重新定义蔬菜购买体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, index) => (
            <div
              key={feat.title}
              className="group p-5 md:p-6 bg-background-100 rounded-xl hover:bg-primary-50/50 transition-all duration-300"
              style={{ animation: `slideUp 400ms ease-out ${index * 80}ms both` }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h4 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}